import { render, staticRenderFns } from "./CaretsUpDown.vue?vue&type=template&id=2d944cb0&"
import script from "./CaretsUpDown.vue?vue&type=script&lang=js&"
export * from "./CaretsUpDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports